import { render, staticRenderFns } from "./PrintWorkersReport.vue?vue&type=template&id=3beeca1b"
import script from "./PrintWorkersReport.vue?vue&type=script&lang=js"
export * from "./PrintWorkersReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports